import { ImageIcon, Plus, Upload } from "lucide-react";
import { LogoDevSearch } from "./LogoDevSearch";
import { LOGO_ACCEPT, LogoImageError, readLogoFile } from "./logo-image";

type Props = {
  /** A logo atual (SVG em texto, ou `data:` de cadastro antigo), ou nulo. */
  value: string | null;
  /** Nova logo escolhida (arquivo ou busca), ou nulo ao remover. Nada é
   *  gravado aqui: quem chama grava no salvar do formulário dele. */
  onChange: (value: string | null) => void;
  /** Erro de leitura do arquivo, pra tela mostrar no lugar dela; nulo limpa. */
  onError: (message: string | null) => void;
};

/**
 * A logo da empresa (2026-10-16): UMA logo só, num cartão compacto com a
 * prévia quadrada, mais a busca pelo nome no Logo.dev ao lado. Usado em
 * Ajustes → Identidade visual e no passo "Empresa" do assistente de
 * configuração, pra as duas telas não divergirem.
 */
export function CompanyLogoField({ value, onChange, onError }: Props) {
  const pick = async (file: File) => {
    onError(null);
    try {
      onChange(await readLogoFile(file));
    } catch (cause) {
      onError(cause instanceof LogoImageError ? cause.message : "Não foi possível ler a imagem.");
    }
  };

  return (
    <div className="company-logo-grid">
      <div className="company-logo-card">
        {value ? (
          <div className="company-logo-frame">
            {/* `<img>` com data URI, NUNCA `innerHTML`: é markup de upload, e
                dentro de `<img>` o navegador não executa script do SVG. */}
            <img
              src={value.startsWith("data:") ? value : `data:image/svg+xml;utf8,${encodeURIComponent(value)}`}
              alt="Logo da empresa"
            />
          </div>
        ) : (
          <div className="company-logo-frame is-empty">
            <ImageIcon size={22} aria-hidden="true" />
          </div>
        )}
        <div className="company-logo-body">
          <strong>Logo</strong>
          <small>
            {value ? "Usada no hub, na Home e no topo das telas." : "Envie um arquivo ou busque pelo nome."}
          </small>
          <div className="company-logo-actions">
            <label className="secondary-button file-button">
              <input
                type="file"
                accept={LOGO_ACCEPT}
                onChange={event => {
                  const file = event.target.files?.[0];
                  if (file) void pick(file);
                  event.target.value = "";
                }}
              />
              {value ? <Upload size={15} /> : <Plus size={16} />} {value ? "Trocar arquivo" : "Escolher arquivo"}
            </label>
            {value && (
              <button type="button" className="text-button" onClick={() => onChange(null)}>
                Remover
              </button>
            )}
          </div>
        </div>
      </div>
      <LogoDevSearch onUse={onChange} />
    </div>
  );
}
